import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NtCompany } from '../../models/nt-company';
import { ISection } from '../../models/group-edit-config';

@Component({
  selector: 'app-asset-select-list-shared',
  templateUrl: './asset-select-list-shared.component.html',
  styleUrls: ['./asset-select-list-shared.component.scss']
})
export class AssetSelectListSharedComponent implements OnInit {
    @Input('assets') set _assets(a: any){
        this.assets = a;
    }
    @Input() company: NtCompany;
    @Input() section: ISection;
    @Input() multiSelect = true;
    @Output() selectionChanged = new EventEmitter<boolean>();

    assets: any[] = [];
    displayColumns = ['selected', 'ref', 'name', 'acq'];
    selectedItemList: number[] = [];
    allSelected=false;
    region: string;

    //@ViewChild('assetTable') assetTable: MatTable<any>;

    constructor() { }

    ngOnInit(): void {
        this.region = this.company.region;
        if(this.company.enableClass){
            this.displayColumns.push('class');
        }
        this.displayColumns.push('location');
        this.section.componentUpdate = this.updateAssets;
    }

    updateAssets = (a: any[]) => {
        this.assets = a;
        //this.assetTable.renderRows();
    }

    selectAllAssets(){
        if(!this.multiSelect){
            return;
        }

        const length = this.assets.length;
        const selLength = this.assets.filter(x=>x.selected).length;

        if(selLength > 0){
            if(selLength === length){
                //deselect all selected
                this.updateAssetSelection(false);
                this.allSelected = false;
            }else{
                this.updateAssetSelection(true);
                this.allSelected = true;
            }
        }else{
            //selected all of the assets and their children
            this.updateAssetSelection(true);
            this.allSelected = true;
        }
        this.selectionChanged.emit(true);
    }

    selectedAssetChanged(id: number, selected: boolean){
        if(this.multiSelect){
            if(this.allSelected && !selected){
                this.allSelected = false;
            }
        }else{
            this.assets.forEach(a => {
                if(a.id !== id){
                    a.selected = false;
                }
            });
        }
        this.selectionChanged.emit(true);
    }

    private updateAssetSelection(state: boolean){
        this.assets.forEach(a => {
            a.selected = state;
            if(a.children){
                a.children.forEach(c => {
                    c.selected = state;
                });
            }
        });
    }
}